import { ITaskRepository } from '@domain/tasks/ITaskRepository';
import { AppTask } from '@domain/tasks/models/Task';
import { Resource } from '@domain/base/Resource';
import { TaskDataSource } from '../datasources/TaskDataSource';
import { TaskMapper } from '../mappers/TaskMapper';

export class TaskRepository implements ITaskRepository {
  constructor(private dataSource: TaskDataSource) {}

  async getTasks(unfinishedOnly = false): Promise<Resource<AppTask[]>> {
    try {
      const tasks = await this.dataSource.getTasks(unfinishedOnly);
      return {
        status: 'success',
        data: tasks.map(TaskMapper.toModel),
      };
    } catch (error) {
      return {
        status: 'error',
        error: {
          type: 'UnknownError',
          message: error instanceof Error ? error.message : 'Failed to get tasks',
        },
      };
    }
  }

  async acknowledgeTask(taskId: string): Promise<Resource<AppTask>> {
    try {
      const task = await this.dataSource.acknowledgeTask(taskId);
      return {
        status: 'success',
        data: TaskMapper.toModel(task),
      };
    } catch (error) {
      return {
        status: 'error',
        error: {
          type: 'UnknownError',
          message: error instanceof Error ? error.message : 'Failed to acknowledge task',
        },
      };
    }
  }
}
